import styled from 'styled-components';
import {alignCenter, alignStart, dFlex, dFlexCenter, dFlexColumn, justifyBetween} from '../../../../globalVariables/GlobalFlex';
import {ellipsisLines} from '../../../../globalVariables/GlobalVariables';

export const list = styled.div`
    ${dFlexColumn};
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    gap: var(--space-md);
    padding: 0 var(--space-lg) var(--space-md);
`;

export const row = styled.div`
    ${dFlex};
    flex: none;
    gap: var(--space-md);
    height: 120px;
    padding: var(--space-md);
    background: var(--color-bg-base-alt);
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--border-radius-border-radius-lg);
`;

export const poster = styled.div`
    position: relative;
    flex: none;
    height: 100%;
    aspect-ratio: 147 / 120;
    overflow: hidden;
    border-radius: var(--border-radius-border-radius-md);

    img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

/* "Redeemed" marker — the event was already redeemed, yet the button stays open for another buy */
export const redeemed = styled.span`
    position: absolute;
    top: var(--space-xs);
    inset-inline-start: var(--space-xs);
    padding: var(--space-2xs) var(--space-sm);
    background: var(--color-bg-base);
    color: var(--color-brand-main);
    border: 1px solid var(--color-border-brand);
    border-radius: var(--border-radius-border-radius-full);
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-semibold);
    white-space: nowrap;
`;

export const main = styled.div`
    ${dFlexColumn};
    ${justifyBetween};
    flex: 1;
    min-width: 0;
    height: 100%;
`;

export const datetime = styled.div`
    ${dFlex};
    gap: var(--space-sm);
    direction: ltr;
    white-space: nowrap;
    font-size: var(--font-size-caption);
    color: var(--color-text-subtle);
`;

export const title = styled.p`
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-medium);
    line-height: 1.2;
    ${ellipsisLines(2)}
`;

export const top = styled.div`
    ${dFlexColumn};
    ${alignStart};
    gap: var(--space-sm);
    width: 100%;
    text-align: start;
`;

export const bottom = styled.div`
    ${dFlex};
    ${alignCenter};
    gap: var(--space-sm);
    width: 100%;
`;

export const status = styled.span<{$available?: boolean}>`
    ${dFlex};
    ${alignCenter};
    flex: 1;
    min-width: 0;
    gap: var(--space-xs);
    font-size: var(--font-size-caption);
    white-space: nowrap;
    color: ${({$available}) => ($available ? 'var(--color-state-success-border)' : 'var(--color-text-subtle)')};

    svg {
        display: block;
        flex: none;
    }
`;

export const checkMarkCircle = styled.span`
    ${dFlexCenter};
    flex: none;
    width: 20px;
    height: 20px;
    border-radius: var(--border-radius-border-radius-full);
    background: var(--color-state-success-bg);
    color: var(--color-state-success-border);
`;

/* Sold out keeps the muted tone the rest of the unavailable states carry — it is a fact
   about the show, not a failure, and the row's text next to it is subtle too */
export const soldOutCircle = styled.span`
    ${dFlexCenter};
    flex: none;
    width: 20px;
    height: 20px;
    border-radius: var(--border-radius-border-radius-full);
    background: var(--color-bg-surface-hover);
    color: var(--color-text-subtle);
`;

export const empty = styled.p`
    padding: var(--space-xl) var(--space-lg);
    text-align: center;
    font-size: var(--font-size-body-small);
    color: var(--color-text-subtle);
`;
